import clsx from "clsx"
import { useState } from "react"

import EmptyRow from "@/ui/components/EmptyRow"
import * as TrinityAPI from "@/requests/TrinityAPI"
import { ModalPopUp } from "@/components/common/element/ModalPopUp"

import { BankTableItem } from "./Item"

import style from "./style.module.scss"

import type { FC } from "react"
import type { ICompanyBank } from "@/types/company/IFullCompanyDto"
import type { IModalMessage } from "@/types/error/IModalMessage"

type Props = {
  payerId: string
  banks: Array<ICompanyBank>
  refetch: () => void
  title: string
}

export const BanksTable: FC<Props> = ({ banks, payerId, refetch, title }) => {
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)

  const handleRemoveBank = (bankId: number) => {
    TrinityAPI.removeCurrencyPayerBank(String(bankId), response => {
      if (response.status === 200) {
        refetch()
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка удаления банка: " + response.data.message })
      }
    })
  }

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />

      <div className="main-content--wrapper">
        <section className="main-content">
          <div className={style.header}>
            <div className={style.title}>Банки (доп. счета) - {title}</div>
          </div>
          <ul className="header-global-list">
            <li className="header-global-item cols-4">Название</li>
            <li className="header-global-item cols-4">SWIFT</li>
            <li className="header-global-item cols-4">Номер счёта</li>
            <li className="header-global-item cols-4">Валюта счёта</li>
          </ul>
          <ul className="global-list">
            {(banks?.length || 0) > 0 ? (
              banks?.map(bank => (
                <BankTableItem onRemove={handleRemoveBank} bank={bank} key={bank.id} refetch={refetch} />
              ))
            ) : (
              <EmptyRow text="Банков не найдено" />
            )}
          </ul>
        </section>
      </div>
    </>
  )
}
